export default "__VITE_ASSET__DWtBx1QM__"